import { Link, useLocation } from "react-router-dom";

import { isRoute, ROUTES } from "~/router/constants";
import { Button } from "~/shared";
import { useNavigationStore } from "~/stores";
import { customIcons } from "~/ui";
import { tw } from "~/utils";
import { Navigation } from "../HubLayout";

const navigation = [
  { name: "Home", href: ROUTES.hubHome },
  { name: "Book a Visit", href: ROUTES.hubBookVisit },
  {
    name: "Patient portal",
    href: "https://31312-1.portal.athenahealth.com",
  },
  { name: "Resources", href: ROUTES.hubResources },
  { name: "Contact us", href: ROUTES.hubContactUs },
  { name: "FAQs", href: ROUTES.hubFaq },
];

export const NavigationItems = () => {
  const location = useLocation();

  const { closeSidebar } = useNavigationStore();

  const link = (navigation: Navigation) => {
    const isCurrent = navigation.href === location.pathname;
    const className = tw(
      "group flex gap-x-3 rounded-sm p-2 text-base font-sans",
      isCurrent
        ? "bg-lavender-mist text-violet font-medium"
        : "hover:bg-light-lavender-gray hover:text-indigo text-indigo font-normal",
    );

    if (isRoute(navigation.href)) {
      return (
        <Link
          to={navigation.href}
          className={className}
          onClick={closeSidebar}
          aria-current={isCurrent ? "page" : undefined}
        >
          {navigation.name}
        </Link>
      );
    }

    return (
      <a
        href={navigation.href}
        className={tw(className, "items-center")}
        target="_blank"
        rel="noopener noreferrer"
      >
        {navigation.name}
        <span className="sr-only"> (opens in a new tab)</span>
        {<customIcons.ArrowUpRightIcon className="size-7" />}
      </a>
    );
  };

  return (
    <section>
      <Button
        asChild
        className="mb-2 px-6 py-2 md:hidden"
        onClick={closeSidebar}
      >
        <Link to={ROUTES.hubBookVisit}>Book a visit</Link>
      </Button>
      <ul role="list" className="space-y-2">
        {navigation.map((item) => (
          <li key={item.name}>{link(item)}</li>
        ))}
      </ul>
    </section>
  );
};
